module.exports = __webpack_public_path__ + "static/videoPlaceholder-1fda264bbee455e42f27236670541bff.png";